import { Progress } from "@/core/components/ui/progress";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import {
  ONBOARDING_STEPS,
  onboardingStepIndex,
  type OnboardingStepPane,
} from "@/onboarding/routes";

// A real bar rather than a row of circles and connectors: it says how far along they are
// at a glance, and it looks identical on every step and at every width, which a stepper
// does not once the labels are different lengths.
export const OnboardingProgress = ({
  activePane,
}: {
  activePane: OnboardingStepPane;
}) => {
  const activeIndex = Math.max(0, onboardingStepIndex(activePane));
  const step = activeIndex + 1;
  const total = ONBOARDING_STEPS.length;

  return (
    <Stack
      gap="xs"
      align="stretch"
      fullWidth
      aria-label="Onboarding progress"
      role="group"
    >
      <Stack
        direction="row"
        justify="between"
        align="baseline"
        gap="sm"
        fullWidth
      >
        <Typography variant="captionW1SemiBold">
          {ONBOARDING_STEPS[activeIndex].label}
        </Typography>
        <Typography variant="captionW1" textColor="tertiary">
          Step {step} of {total}
        </Typography>
      </Stack>
      {/* Neutral track and a green fill: the primitive defaults to the brand red-orange,
          which reads as a warning on a progress bar, and progress everywhere else in this
          flow is green. bg-brand is a gradient, so the fill needs the image cleared as
          well as the colour set, and both have to outrank the indicator's own class. */}
      <Progress
        value={(step / total) * 100}
        className="bg-stroke-tertiary [&>div]:!bg-primary [&>div]:!bg-none"
      />
    </Stack>
  );
};
